import { render, staticRenderFns } from "./WorkflowHistory.vue?vue&type=template&id=2f50f7bd&lang=html&"
import script from "./WorkflowHistory.vue?vue&type=script&lang=js&"
export * from "./WorkflowHistory.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowHistory.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports